import ApiService from '../data/services/ApiService'

export const motivosCancelacionCFDI = [
    { value: '00', label: 'Selecciona el motivo de cancelación' },
    { value: '01', label: 'Comprobante emitido con errores con relación' },
    { value: '02', label: 'Comprobante emitido con errores sin relación' },
    { value: '03', label: 'No se llevó a cabo la operación' },
    { value: '04', label: 'Operación nominativa relacionada en la factura global' }
]

export const motivosCancelacionPagos20 = [
    { value: '00', label: 'Selecciona el motivo de cancelación' },
    { value: '01', label: 'Comprobante emitido con errores con relación' },
    { value: '02', label: 'Comprobante emitido con errores sin relación' },
    { value: '03', label: 'No se llevó a cabo la operación' },
    { value: '04', label: 'Operación nominativa relacionada en la factura global' }
]

export const cancelarComplemento = async ({ id, motivo, folioSustitucion }) => {
    return await ApiService.cancelarComplemento(id, {
        motivo,
        folioSustitucion
    })
}

export const cancelarComplementoConValidacion = async ({ complementoId, cancelReason, folioSustitucion }) => {
    if (!complementoId || !cancelReason?.value || cancelReason.value === '00') {
        throw new Error('Selecciona un motivo de cancelación')
    }

    if (cancelReason.value === '01' && !folioSustitucion) {
        throw new Error('Escribe el folio de la factura sustituta')
    }

    return await cancelarComplemento({
        id: complementoId,
        motivo: cancelReason.value,
        folioSustitucion
    })
}
